import React from 'react';
import { useNavigate } from 'react-router-dom';
import { database } from '../data/database.ts';

const Products: React.FC = () => {

  const navigate = useNavigate();
  const db = database.products;

  const handleProductClick = (id: number) => {
    navigate(`/productos/${id}`);
  };

  return (
    <section id="products" className="products section">

      <div className="container" data-aos="fade-up">
        <h2 className="section-title">Productos</h2>
      </div>

      <div className="container">
        <div className="row gy-4 align-items-center">
        {
          db.items.map((item, index) => (
            <div key={index} className="col-xl-4 col-md-6" data-aos="fade-down" data-aos-delay="300">
              <div className="products-item" onClick={() => handleProductClick(item.id)}>
                <div className="product-image">
                  <img src={item.image} alt="" className="default-image" />
                  <img src={item.hoverImage} alt="" className="hover-image" />
                  <span className="product-review">Vista rápida</span>
                </div>
                <span className="product-name">{item.name}</span>
                <span className="product-price">{item.currency} {item.priceFinalOffer}.00</span>
              </div>
            </div>
          ))
        }
        </div>
      </div>

    </section>
  );
};

export default Products;
